<template>
  <div class="d-flex align-center">
    <div
      class="priority-icon-container d-flex align-center justify-center mr-1"
      :class="`${priorityProps.backgroundColor}`"
    >
      <v-icon size="12" :color="priorityProps.iconColor">
        {{ priorityProps.iconName }}
      </v-icon>
    </div>
    <p
      class="ma-0 pa-0"
      :class="[`priority-${priority}`, small ? 'font-size-10' : 'caption']"
    >
      {{ $t(`rev.priority.${priority}`) }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Priority',

  props: {
    priority: String,
    small: Boolean,
  },

  computed: {
    priorityProps() {
      return this.$constants.PRIORITY_PROPS[this.priority]
    },
  },
}
</script>

<style scoped lang="scss">
.priority-icon-container {
  border-radius: 16px;
  width: 18px;
  height: 18px;
}
.priority-low {
  color: $color-blue;
}
.priority-medium {
  color: $color-yellow-darken1;
}
.priority-high {
  color: $color-red;
}
</style>
